const key = setInterval(() => {
  const carouselItem = document.querySelector(
    '#recommendations-app-264 a.grid-item-info-content'
  )
  if (carouselItem) {
    clearInterval(key)
    /* Carousel is mounted. Do stuff here */
    setTimeout(() => {
     //mutateCarouselHTML();
    }, "1500");
  }
}, 25)
setTimeout(
  () => clearInterval(key) /* Just in case something fails to load */,
  20000
)



function observeWithTimer(target, callback, timeout = 500) {
  let timerID;
  // Check if target is a valid DOM node
  if (!target || !(target instanceof Node)) {
    console.warn('Invalid target for MutationObserver');
    return null;
  }
  
  const observer = new MutationObserver(function(mutationsList, observer) {
    clearTimeout(timerID);
    timerID = setTimeout(function() {
      observer.disconnect();
      callback();
    }, timeout);
  });

  observer.observe(target, { childList: true, subtree: true });

  return observer;
}

const ObserveTarget = document.getElementById('recommendations-app-264');

if (ObserveTarget) {
  observeWithTimer(ObserveTarget, function() {
    //mutateCarouselHTML();
  }, 1000);
}



function observeWithRestartingTimer(target, callback, timeout = 500) {
  // Check if target is a valid DOM node
  if (!target || !(target instanceof Node)) {
    console.warn('Invalid target for MutationObserver');
    return {
      disconnect: function() {},
      restartTimer: function() {}
    };
  }
  
  let timerID;
  let isCallbackTriggered = false;

  const observer = new MutationObserver(function(mutationsList, observer) {
    clearTimeout(timerID);
    timerID = setTimeout(function() {
      if (!isCallbackTriggered) {
        isCallbackTriggered = true;
        callback();
      }
    }, timeout);
  });

  observer.observe(target, { childList: true, subtree: true });

  return {
    disconnect: function() {
      observer.disconnect();
      clearTimeout(timerID);
    },
    restartTimer: function() {
      clearTimeout(timerID);
      timerID = setTimeout(function() {
        if (!isCallbackTriggered) {
          isCallbackTriggered = true;
          callback();
        }
      }, timeout);
    }
  };
}

const target = document.getElementById('recommendations-app-264');
const target2 = document.getElementById('recommendations-app-447');

if (target) {
  const observer = observeWithRestartingTimer(target, function() {
    //console.log('No changes detected for 1 second');
    mutateCarouselHTML();
  }, 1000);
}

function waitThreeSeconds(callback) {
  setTimeout(callback, 3000);
}

waitThreeSeconds(function() {
  if (target2) {
    const observer2 = observeWithRestartingTimer(target2, function() {
      //console.log('No changes detected for 1 second');
      mutateMobileCarouselHTML();
    }, 5000);
  }
});

function insertAfter(newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}


function mutateCarouselHTML(){
    const target = document.getElementById('recommendations-app-264');
    if (!target) return;
    
    const xingminds_array = target.querySelectorAll('a.grid-item-info-content');
    for (let i of xingminds_array) {
      let url = i.href;
      let startIndex = url.lastIndexOf("/") + 1;
      let endIndex = url.lastIndexOf("?");
      let handle = url.substring(startIndex, endIndex);
      i.parentElement.innerHTML += `<button class='button quick-view is-small is-info' data-handle='${handle}' style='width:100%;'>Add to Cart</button>`;
    }
}


function mutateMobileCarouselHTML(){
  const target2 = document.getElementById('recommendations-app-447');
  if (!target2) return;
  
  const xingminds_array2 = target2.querySelectorAll('.slick-slide');
    for (let i of xingminds_array2) {
      let url = i.querySelector('a')?.href;
      if (!url) continue;
      
      let startIndex = url.lastIndexOf("/") + 1;
      let endIndex = url.lastIndexOf("?");
      let handle = url.substring(startIndex, endIndex);
      let btn = document.createElement('button');
      btn.classList.add('button', 'quick-view','is-small', 'is-info');
      btn.dataset.handle = handle;
      btn.style.width = "70%";
      btn.style.marginLeft = "15%";
      btn.innerText = "Add to Cart";
      insertAfter(btn, i.lastElementChild);
    }
    //30% OFF SALE
    const rprices = document.querySelectorAll('.grid-item-price-value');
    rprices.forEach(element => {
      // Get the current price from the text content
      const currentPrice = parseFloat(element.textContent.replace('$', ''));
      // Calculate the new price with the 30% discount
      const newPrice = currentPrice * 0.7;
      
      // Update the text content to show the new price with the dollar sign
      element.innerHTML = `<strike>$${currentPrice}</strike>&nbsp;$${newPrice.toFixed(2)}`;
    });
}
  